import * as React from "react";
const SvgCalendar = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13.334 2.5V5.83333M6.66732 2.5V5.83333M3.33398 9.16667H16.6673M5.83398 11.6667H5.84482M8.34212 11.6667H8.34629M10.8421 11.6667H10.8463M13.3462 11.6667H13.3504M10.8462 14.1667H10.8504M5.84212 14.1667H5.84629M8.34212 14.1667H8.34629M3.33398 5.83333C3.33398 5.39131 3.50958 4.96738 3.82214 4.65482C4.1347 4.34226 4.55862 4.16667 5.00065 4.16667H15.0007C15.4427 4.16667 15.8666 4.34226 16.1792 4.65482C16.4917 4.96738 16.6673 5.39131 16.6673 5.83333V15.8333C16.6673 16.2754 16.4917 16.6993 16.1792 17.0118C15.8666 17.3244 15.4427 17.5 15.0007 17.5H5.00065C4.55862 17.5 4.1347 17.3244 3.82214 17.0118C3.50958 16.6993 3.33398 16.2754 3.33398 15.8333V5.83333Z",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgCalendar;
